import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { BrochureDetailBlockViewModel } from './BrochureDetailModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import Share from '@/components/Share/Share.vue';
import TitleHeader from '@/components/TitleHeader/TitleHeader.vue';
import { PageMeta, PAGE_META } from '@/store/modules/metadataModule';
import { Getter } from 'vuex-class';
import DownloadGateMixin from '@/mixins/DownloadGateMixin';
import { getStore } from '@/store';

@Component({
  props: getComponentProps<BrochureDetailBlockViewModel>({
    Locations: ['Alaska'],
    Destinations: [1, 12],
    Image: { Url: '', Alt: '' },
    Name: 'Alaska 2020-21',
    Text: 'Breathtaking photos',
    PDF: '#',
    ViewCode: '',
    IsBtB: false,
    DirectMail: true,
    Download: true,
    BackLink: {
      Link: '#',
      Title: 'Back to all brochures',
    },
  }),
  components: {
    Share,
    TitleHeader,
  },
})
export default class BrochureDetailModule extends mixins(DownloadGateMixin) {
  readonly p!: BrochureDetailBlockViewModel;

  @Getter(PAGE_META)
  PageMeta!: PageMeta;

  get titleHeaderData() {
    return {
      Title: this.p.Name,
      Text: this.p.Text,
      Link: this.p.BackLink,
      Center: false,
    };
  }
  mounted() {
    const { Analytics } = getStore().state.Meta;
    const { brochures } = Analytics;
    const gateAnalytics = {
      brochures: [{
        brochure_id: brochures[0].brochure_id,
        brochure_name: brochures[0].brochure_name,
        brochure_code: brochures[0].brochure_code,
        quantity: 1,
        image_url: `${document.location.origin}${this.p.ImageUrl}`,
      }]
    }
    this.newsletterPopup.Data.AnalyticsData = gateAnalytics;
  }
}
